import { movies } from "@/mocks/movies";
import { scenarios } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function ScenarioPicks() {
  return (
    <section id="scenarios" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="按场景选片"
          title="不同心情，不同的观影入口"
          description="有时候不是不知道有哪些电影，而是不知道此刻适合看什么。先选一个场景，再看对应的片单，会快很多。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {scenarios.map((scenario) => (
            <article
              key={scenario.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${scenario.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {scenario.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {scenario.description}
              </p>
              <div className="mt-4 space-y-2 border-t border-background-200 pt-4">
                {scenario.movieIds.map((id) => {
                  const movie = movies.find((m) => m.id === id);
                  if (!movie) return null;
                  return (
                    <div key={id} className="flex items-center gap-3">
                      <div className="h-14 w-10 shrink-0 overflow-hidden rounded bg-background-100">
                        <img
                          src={movie.poster}
                          alt={`${movie.title} 电影海报`}
                          title={`${movie.title} 场景推荐海报`}
                          className="h-full w-full object-top object-cover"
                        />
                      </div>
                      <div className="min-w-0">
                        <p className="truncate font-heading text-sm font-semibold text-foreground-900">
                          {movie.title}
                        </p>
                        <p className="font-label text-xs text-foreground-500">
                          {movie.genre} · {movie.rating.toFixed(1)} 分
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}